<style scoped>
.el-col-5{
  width: 30%;
}
  
</style>
<template>
  <div class="content">
    <div class="search-area">
      <el-row :gutter="24"> 
        <el-col :span="8"
          ><div class="search-area-div">算法名称：</div>
          <el-select v-model="page.repositoryGuid" placeholder="请选择" class="w70f" filterable @change="selectRepository(page.repositoryGuid)">
            <el-option
              v-for="item in repositoryNameList"
              :key="item.guid"
              :label="item.repositoryName"
              :value="item.guid">
            </el-option>
          </el-select>
          </el-col>
        <!-- <el-col :span="8">
          <el-button size="medium" type="info" @click="getData(true)">搜索</el-button>
          <el-button size="medium" type="danger" @click="empty">清空</el-button>
        </el-col> -->
      </el-row>
    </div>
    <div class=" back-color-fff mt15" style="padding: 16px;">
      <el-table :data="tableData" border style="width: 100%;" v-loading="loading">
        <el-table-column label="序号" width="60" header-align="center" align="center">
          <template slot-scope="scope">
            <!-- {{ scope.$index + 1 }} -->
            {{(page.pageIndex - 1) * page.pageSize + scope.$index + 1}}
          </template>
        </el-table-column>
        <el-table-column prop="tenantName" label="会员名称" header-align="center" align="center"></el-table-column> 
        <el-table-column label="参数设置" header-align="center" align="center">
          <template slot-scope="scope">
            <a class="txt-color" @click="toLink(scope.row.tenantGuid)">设置及修改</a>
          </template>
        </el-table-column>
        <el-table-column label="操作" header-align="center" align="center">
          <template slot-scope="scope">
            <a class="txt-color" v-if="repositoryName == '选品算法'" @click="goodsSelect(scope.row.tenantGuid)">计算</a>
            <a class="txt-color" v-if="repositoryName == '销售预测'" @click="getGoodsForecast(scope.row.tenantGuid)">计算</a> 
            <a class="txt-color" v-if="repositoryName == 'RDC选仓分析'" @click="warehouseChoose(scope.row.tenantGuid)">计算</a> 
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      class="pt pb back-color-fff"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 100, 200]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRows"
    >
    </el-pagination> 
  </div>
</template>

<script>
export default {
  data() {
    return {
      input: '',
      textTitle: '',
      right: '',
      loading:false,
      dialogVisible: false,
      dialogFormVisible: false,
      formLabelWidth: '120px',
      repositoryName:'',
      ruleForm: {
        guid: '',
        tenantGuid: '',
        tenantName: '', 
        parameterGuid: '',
        parameter:'',
        repositoryGuid: '',
        repositoryName:'',
        value:'Y'
      },
      tenantGuid:'',
      repositoryGuid:'',
      page: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0, 
        tenantName: '',
        repositoryGuid: '', 
        repositoryName: '',
        parameterGuid:'',
        tenantGuid: '', 
        repositoryName: '',
        parameter:'', 
      },
      dto:{
        pageIndex: 1,
        pageSize: -1,
        totalPage: 0,
        totalRows: 0, 
        tenantGuid: '',
      },
      tableData: [],
      rules: { 
          tenantGuid: [
            { required: true, message: '请选择会员名称', trigger: 'change' }
          ],
          parameterGuid: [
            { required: true, message: '请选择参数配置', trigger: 'change' }
          ],
          repositoryGuid: [
            { required: true, message: '请选择算法名称', trigger: 'change' }
          ],
      },
      multipleSelection: [],
      repositoryTypeList:[],
      repositoryNameList:[],
      parameterList:[],
      tenantList:[],
    };
  },
  created() {
    // 列表 
    this.getrepositoryTypeList();
  },
  methods: {
    empty() {
      let self = this;
      self.page = {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        tenantName: '',
        repositoryGuid: '', 
        repositoryName: '', 
      };
      self.getData(true);
    },
    getData(flg) {
      let self = this;
      if (flg) {
        self.page.pageIndex = 1;
      }
      // self.page.tenantGuid = self.$store.getters.getTenantGuid;
      self.api.postJson(`/${serverConfig.msAiAlgorithmService}/sys-conf/import-param-val-tenant/get`, self.page).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records;
          // self.tableData.forEach(function(item) {
          //   item.bizState = item.bizState == 'Y' ? '有效' : '停用';
          // });
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    selectRepository(repositoryGuid){
      let self = this;
       self.page.repositoryGuid = repositoryGuid;
       self.repositoryNameList.forEach(function(i){
        console.log(repositoryGuid,i.guid);
            if(repositoryGuid == i.guid){
                    self.repositoryName = i.repositoryName;
            }
       })
       self.getData(false); 
    },
    getrepositoryTypeList() {
      let self = this;
      // self.dto.enterpriseCate = '010201';
      self.api.postJson(`/${serverConfig.msAiAlgorithmService}/math-repository/data/get`, self.dto).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.repositoryNameList = res.data.data.records;
          if(res.data.data.records != null){
            self.page.repositoryGuid = res.data.data.records[0].guid;
            self.repositoryName = res.data.data.records[0].repositoryName;
            this.getData(false); 
          }
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    goodsSelect(tenantGuid) {
      let self = this; 
      self.loading = true;
      self.api.postJson(`/${serverConfig.msAiAlgorithmService}/goods-select/goods-select`,{'tenantGuid':tenantGuid,'repositoryGuid':self.page.repositoryGuid}).then(res => {
        self.loading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
           self.$message.success("计算完成");
        } else {
           self.$message.error(res.data.msg);
        }
      });
    },
    getGoodsForecast(tenantGuid) {
      let self = this; 
      self.loading = true;
      self.api.postJson(`/${serverConfig.msAiAlgorithmService}/goods-forecast/goods-forecast`,{'tenantGuid':tenantGuid,'repositoryGuid':self.page.repositoryGuid}).then(res => {
        self.loading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) { 
          self.$message.success("计算完成");
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    warehouseChoose(tenantGuid) {
      let self = this; 
      self.loading = true;
      self.api.postJson(`/${serverConfig.msAiAlgorithmService}/warehouse-select/warehouse-choose`,{'tenantGuid':tenantGuid,'repositoryGuid':self.page.repositoryGuid}).then(res => {
        self.loading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) { 
          self.$message.success("计算完成");
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    toLink(tenantGuid){
             this.$router.push({path: "/tenantAlgorithmicCalculationDetails", query:{productGuid:this.$route.query.productGuid,tenantGuid:tenantGuid,repositoryGuid:this.page.repositoryGuid}})
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getData();
    },
  },
};
</script>
